import React, {
  useState,
  useContext
} from 'react';
import {
  Box,
  Card,
  CardHeader,
  CardContent,
  Divider,
  Grid,
} from '@material-ui/core';
import {
  VALIDATOR_REQUIRE,
  VALIDATOR_MINLENGTH,
} from '../../utils/validators';
import Input from '../../shared/component/FormElements/Input';
import Button from '../../shared/component/FormElements/Button';
import { useForm } from '../../hooks/form-hook';
import { useHttpClient } from '../../hooks/http-hook';
import { AuthContext } from '../../shared/context/auth-context';
import ErrorMessage from '../../shared/component/UIElements/ErrorMessage';
import LoadingSpinner from '../../shared/component/UIElements/LoadingSpinner';

// Alerta
import Alerta from './Alerta';

const Senha = () => {
  const auth = useContext(AuthContext);
  // const classes = useStyles();
  const {
    isLoading,
    error,
    sendRequest,
    clearError
  } = useHttpClient();
  const [formState, inputHandler] = useForm({
    senhanova: {
      value: '',
      isValid: false
    },
    senhanovadois: {
      value: '',
      isValid: true
    },
  }, false);
  const [salvou, setSalvou] = useState(false);

  const senhaSubmitHandler = async (event) => {
    event.preventDefault();
    console.log('Inputs');
    console.log(formState.inputs);
    try {
      const formulario = {
        senhanova: formState.inputs.senhanova.value,
        senhanovadois: formState.inputs.senhanovadois.value,
      };
      const response = await sendRequest(
        `${process.env.REACT_APP_BACKEND_URL}/usuarios/perfil/senha/`,
        'POST',
        JSON.stringify(formulario),
        {
          'Content-Type': 'application/json',
          'x-access-token': auth.token,
        }
      );
      if (response.sucesso) {
        setSalvou(true);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const fechar = () => {
    setSalvou(false);
  };

  if (isLoading) {
    return (
      <Grid
        container
        spacing={3}
      >
        <Grid
          item
          lg={4}
          md={6}
          xs={12}
        >
          <LoadingSpinner asOverlay />
        </Grid>
      </Grid>
    );
  }

  return (
    <form onSubmit={senhaSubmitHandler}>
      <Grid
        container
        spacing={3}
      >
        <Grid
          item
          lg={12}
          md={12}
          xs={12}
        >
          <Card>
            <CardHeader
              subheader="Atualize aqui sua senha."
              title="Perfil"
            />
            <Divider />
            <CardContent>
              <Grid
                container
                spacing={3}
              >
                <Grid
                  item
                  md={6}
                  xs={6}
                >
                  <Input
                    id="senhanova"
                    element="input"
                    type="password"
                    label="Alterar senha do Usuário"
                    fullWidth
                    validators={[VALIDATOR_MINLENGTH(7), VALIDATOR_REQUIRE()]}
                    errorText="Insira uma senha para o Usuário com no mínimo 7 dígitos."
                    onInput={inputHandler}
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>
                <Grid
                  item
                  md={6}
                  xs={6}
                >
                  <Input
                    id="senhanovadois"
                    element="input"
                    type="password"
                    label="Alterar senha do Usuário"
                    fullWidth
                    validators={[VALIDATOR_MINLENGTH(7), VALIDATOR_REQUIRE()]}
                    errorText="Insira uma senha para o Usuário com no mínimo 7 dígitos."
                    onInput={inputHandler}
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>
              </Grid>
            </CardContent>
            <Divider />
            <Box
              display="flex"
              justifyContent="flex-start"
              p={2}
            >
              <Button
                color="primary"
                variant="contained"
                type="submit"
                disabled={!formState.isValid}
              >
                Salvar
              </Button>
            </Box>
          </Card>
        </Grid>
        <Grid
          item
          lg={4}
          md={6}
          xs={12}
        >
          <ErrorMessage error={error} onClear={clearError} />
        </Grid>
      </Grid>
      <Alerta open={salvou} close={fechar} tipo="success">Senha atualizada com sucesso!</Alerta>
    </form>
  );
};

export default Senha;
